import { useQuery, UseQueryOptions } from 'react-query';
import { BranchPartnersService } from '../../services';
import { IBranchPartner } from '../../interfaces';

export const useBranchPartners = (query = {}, options?: UseQueryOptions<IBranchPartner[], Error, IBranchPartner[], ['branch-partners', object]>) => {
  return useQuery<IBranchPartner[], Error, IBranchPartner[], ['branch-partners', object]>(
    ['branch-partners', query],
    async ({ queryKey }) => {
      const [, params] = queryKey;
      const result = await BranchPartnersService.getList({ page: 1, per_page: 5000, ...params });
      if (result.status === 200) return result.data.data;
      throw new Error(result.data as string);
    },
    { staleTime: 5 * 60 * 1000, ...options },
  );
};
